import React, { Component } from 'react';
import PropTypes from 'prop-types';
import appucationsLogo from '../../appucations_logo_final-retina.png';

export default class Login extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
    };
  }

  handleChange = (ev) => {
    this.setState({[ev.target.name]: ev.target.value });
  };

  handleLogin = (ev) => {
    ev.preventDefault();
    this.props.login(this.state.username, this.state.password);
  };
  render() {
    
    return (
      <div className="wrapper fadeInDown">
        <div id="formContent">
          <div className="appInfo">
            <img src={appucationsLogo} alt="appucations logo" />
            <h1>Smart-O-Meter</h1>
          </div>
          <form>
            <input 
              type="text"
              value={this.state.username}
              className="fadeIn second" 
              name="username" 
              placeholder="Benutzername"
              onChange={(ev) => this.handleChange(ev)}
             />
            <input 
              type="password"
              value={this.state.password}
              className="fadeIn third" 
              name="password" 
              placeholder="Passwort"
              onChange={(ev) => this.handleChange(ev)}
             />
            <button onClick={this.handleLogin} className="fadeIn fourth submit">Einloggen</button>
          </form>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/Login.js